module.exports = __webpack_public_path__ + "static/img/withdrawal_tips.5d23122.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/withdrawal_tips.png
// module id = 5jUY
// module chunks = 1